import {poStatusOptions, searchMaxLength} from 'utils/constants';
import {HiOutlineCalendar, HiOutlineSearch, HiOutlineX} from 'react-icons/hi';
import './actionTable.scss';
import {useTranslation} from 'react-i18next';
import {isEmpty} from 'lodash';
import Buttons from "../button/Buttons";
import {useEffect, useRef, useState} from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css'; // Import a Flatpickr theme
import SelectMulti from 'components/select/multiSelect';
type buttonProps = {
    buttonName: string,
    buttonHidden: boolean,
    buttonAction: Function,
    className?: string,
};
const ActionTable = (props: any) => {
    const {
        placeholderSearch,
        buttonName,
        buttons,
        handleAddClick,
        buttonExports,
        handleSearch,
        searchValue,
        leftContent,
        hiddenSearch = false,
        fDate, setFDate,
        tDate, setTDate,
        status, setStatus,
        type
    } = props;
    const [t] = useTranslation();
    const [localSearch, setLocalSearch] = useState(searchValue || '');
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [statusTypeOptions, setStatusTypeOptions] = useState(poStatusOptions);
    const flatpickrRef = useRef<Flatpickr | null>(null);
    const [dateFilter, setDateFilter] = useState<any>([]);

    useEffect(() => {
        setLocalSearch(searchValue || '');
    }, [searchValue]);

    const handleOnKeyUp = (e: any) => {
        const {key} = e;
        if (key === 'Enter') handleSearch(localSearch);
    };

    const handleOnChange = (e: any) => {
        const val = e.target.value;
        setLocalSearch(val);
        if (isEmpty(val)) handleSearch(val);
    };

    const handleChangeStatus = (options: any) => {
        setSelectedStatus(options);
        if (options?.length > 0) {
            const sta: any = [];
            for (let index = 0; index < options?.length; index++) {
                const element = options[index];
                sta.push(element?.value);
            }
            setStatus(sta);
        } else {
            setStatus([]);
        }
    };

    const handleChangeDate = (option: any) => {
        if (option) {
            if (option[0]) {
                setFDate((option[0] as Date).toLocaleDateString());
            }

            if (option[1]) {
                setTDate((option[1] as Date).toLocaleDateString());
            }
            setDateFilter(option);
        } else {
            setFDate('');
            setTDate('');
            setDateFilter([]);
        }
    };

    const handleClearSelection = () => {
        if (flatpickrRef.current) {
            flatpickrRef.current.flatpickr.clear();
            setFDate('');
            setTDate('');
        }
    };

    // @ts-ignore
    return (
        <div className="flex pb-3 justify-between action-table">
            <div className="left">
                    <div
                        className="flex items-center text-search border border-gray-200 mr-[15px] action-search rounded-sm pl-2 h-[36px]">
                        {!hiddenSearch && (
                            <span className="pl-1"><HiOutlineSearch strokeWidth={3} className="w-4 h-4"/></span>
                        )}
                        <input
                            className="px-2 text-sm border-0 focus:outline-none focus:drop-shadow-none w-full bg-transparent"
                            type="search"
                            name="search"
                            hidden={hiddenSearch}
                            maxLength={searchMaxLength}
                            placeholder={placeholderSearch}
                            value={localSearch}
                            onChange={e => handleOnChange(e)}
                            onKeyUp={e => handleOnKeyUp(e)}
                        />
                    </div>
                    {leftContent}
                    {type === "poList" && (<SelectMulti
                        data={statusTypeOptions}
                        selectedData={status}
                        setSelectedData={setStatus}
                        placeholder={t('itemPage.status')}
                    />)}
                {type === "poList" &&
                    (
                        <div className="custom-date-range">
                            <Flatpickr
                                ref={flatpickrRef}
                                value={dateFilter}
                                onChange={(e: any) => handleChangeDate(e)}
                                options={
                                    {
                                        mode: 'range',
                                        dateFormat: 'M-d-Y'
                                    }
                                }
                                placeholder="Date Range"
                            />
                            {fDate !== '' && tDate !== '' ?
                                <button onClick={handleClearSelection}><HiOutlineX/></button> : <HiOutlineCalendar/>}
                        </div>
                    )}
            </div>

            <div className="flex flex-wrap justify-end items-center gap-2 action-button">
                <div className="flex gap-2 items-center">
                    {buttons
                        ? buttons.map((button: buttonProps) => {
                            return (
                                <>
                                    {button.buttonHidden && (
                                        <Buttons className={button.className || 'text-white bg-secondary !px-2 !whitespace-nowrap'} text={button.buttonName}
                                                 onClick={() => button.buttonAction()}/>
                                    )}
                                </>
                            );
                        })
                        : handleAddClick && (
                        <Buttons className="text-white bg-secondary !whitespace-nowrap" text={buttonName}
                                 onClick={() => handleAddClick()}/>
                    )}
                </div>
                {buttonExports && (
                    <div className="flex gap-2 items-center">
                        {buttonExports.map((buttonExport: buttonProps) => {
                            return (
                                <Buttons className="text-secondary border border-secondary !px-2 !whitespace-nowrap"
                                         text={buttonExport.buttonName} onClick={() => buttonExport.buttonAction()}/>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};
export default ActionTable;
